export const SET_LOCALE = 'EXAMPLE/TEST_ACTION';
